<template>
  <div class="container">
    <div ref="local-store">
      <div class="handle-box">
        <el-input v-model="query.name" placeholder="门店名称" class="handle-input mr10"></el-input>
        <el-select v-model="query.admin_id" clearable placeholder="管理员" class="handle-input mr10">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="query.area_id" clearable placeholder="开放地址" class="handle-input mr10">
          <el-option v-for="item in area_options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="query.phone" placeholder="电话" class="handle-input mr10"></el-input>
        <el-select v-model="query.is_validate" clearable placeholder="有效性" class="handle-select mr10">
          <el-option key="1" label="有效" value="1"></el-option>
          <el-option key="2" label="无效" value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      </div>
      <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="门店名" show-overflow-tooltip header-align="center"></el-table-column>
        <el-table-column label="封面" align="center" width="100" header-align="center">
          <template #default="scope">
            <el-image class="table-td-thumb" :src="scope.row.cover" :preview-src-list="[scope.row.cover]"
              :hide-on-click-modal="true"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="营业时间" align="center">
          <template #default="scope">
            {{ getNumberHour(scope.row.start_hour, true) }}
            -
            {{ getNumberHour(scope.row.end_hour, true) }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
        <el-table-column label="是否有效" width="100" align="center">
          <template #default="scope">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template #default="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
            <el-button type="text" @click="getManager(scope.row.id)">店长
            </el-button>
            <el-button type="text" @click="getCleaning(scope.row.id)">保洁
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
          :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="titleName" v-model="editVisible" width="80%">
      <el-tabs v-model="activeTab" type="card" @tab-click="changeTab">
        <el-tab-pane name="info" label="基本信息">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="105px" :rules="rules">
            <el-form-item label="门店名" prop="name">
              <el-input v-model="form.name" class="w400" disabled></el-input>
            </el-form-item>
            <el-form-item label="开放地址">
              <el-select v-model="form.area_id" disabled>
                <el-option v-for="item in area_options" :key="item.value" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="绑定加盟商" prop="type">
              <el-select v-model="form.company_id" filterable placeholder="输入加盟商名可搜索" disabled>
                <el-option v-for="item in franchiseeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="营业时间" prop="start_hour">
              <div>
                <el-checkbox-group v-model="weekDays">
                  <el-checkbox :label="item.label" v-for="item in weekTime" :key="item.value"></el-checkbox>
                </el-checkbox-group>
              </div>
              <div>
                <el-time-select placeholder="开始时间" v-model="form.start_hour" start="00:00" step="01:00" end="23:00">
                </el-time-select>
                -
                <el-time-select placeholder="结束时间" v-model="form.end_hour" start="00:00" step="01:00" end="23:00">
                </el-time-select>
                <span class="qf">{{ form.hour_invert ? '不营业 ' : ' 营 业' }} <el-switch v-model="form.hour_invert"
                    class="ml10"></el-switch></span>
                <el-tooltip class="item" effect="dark" content="点击按钮切换营业状态，显示营业则说明所选择的时间为营业状态，否则代表为不营业状态"
                  placement="top-start">
                  <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="休业时间">
              <el-date-picker placeholder="开始时间" v-model.number="form.stop_start_at_t" format="YYYY-MM-DD HH:mm"
                value-format="timestamp" type="datetime">
              </el-date-picker>
              -
              <el-date-picker placeholder="结束时间" v-model.number="form.stop_end_at_t" format="YYYY-MM-DD HH:mm"
                value-format="timestamp" type="datetime">
              </el-date-picker>
              <el-tooltip class="item" effect="dark" content="该时间段门店将无法下单，为休业状态" placement="top-start">
                <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="无人值守时间">
              <el-select v-model="form.auto_start_at" placeholder="开始时间">
                <el-option v-for="(item, index) in 24" :key="index" :label="'今日 ' + index + ':00'" :value="index">
                </el-option>
              </el-select>
              -
              <el-select v-model="form.auto_end_at" placeholder="开始时间">
                <el-option v-for="(item, index) in 24" :key="index" :label="'次日 ' + index + ':00'" :value="index">
                </el-option>
              </el-select>
              <el-tooltip class="item" effect="dark" content="该时间对应的是今日至次日，选择之后门店每个包厢在该时间段只能下一单，适合在无人打扫的情况时使用"
                placement="top-start">
                <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="封面">
              <el-alert title="建议尺寸780（长）*560（宽）" type="success" style="margin-bottom: 10px;" />
              <el-upload class="avatar-uploader" :show-file-list="false" :on-change="handleCoverChange"
                list-type="picture-card" :auto-upload="false">
                <img v-if="form.cover" :src="form.cover" class="avatar2">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="封面轮播图">
              <el-alert title="建议尺寸780（长）*560（宽）" type="success" style="margin-bottom: 10px;" />
              <template v-for="(item, index) in form.image_list" :key="index">
                <div style="float:left; margin: 5px;">
                  <img :src="item" class="avatar2">
                  <el-button type="text" @click="form.image_list.splice(index, 1)" style="color: red">删除</el-button>
                </div>
              </template>
              <el-upload :show-file-list="false" list-type="picture-card" :auto-upload="false"
                :on-change="handleChange">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="经纬度">
              <el-button type="primary" class="qf" icon="el-icon-map-location"
                style="color: white;margin-left: 0;width: 100px;"><a class="target" href="https://lbs.qq.com/getPoint"
                  target="_blank" style="color: white">地图选点</a>
              </el-button>
              :
              <el-input v-model="form.tude" style="display: inline-block; width: 200px;"></el-input>
              <el-tooltip class="item" effect="dark" content="选择完地址之后需要将经纬度复制在后方的输入框内" placement="top-start">
                <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input v-model="form.address" style="width: 500px;"></el-input>
            </el-form-item>
            <el-form-item label="负责人">
              <el-select v-model="form.admin_id" placeholder="请选择" style="width: 200px;">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="form.phone" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="详情">
              <tinymce-text id="tinymce" @input="tinymcechange" @release="release"
                v-model:value="form.content"></tinymce-text>
            </el-form-item>
          </el-form>
          <span class="other-footer">
            <el-button @click="editVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveEdit">确 定</el-button>
          </span>
        </el-tab-pane>
        <el-tab-pane name="time" label="营业时间">
          <div class="demo-collapse">
            <el-collapse v-for="(item, index) in weekList" :key="index">
              <el-collapse-item :title="item.label" name="1">
                <div class="time_box">
                  <div v-for="(time, time_index) in item.timeList" :key="time_index"
                    :class="time.is_select ? 'time_active' : 'time_item'" @click="changeAtive(index, time_index)">
                    {{ time.time1 }}
                  </div>
                </div>
                <div class="btn_style">
                  <el-button @click="handleAllSelect(index)">
                    全选
                  </el-button>
                  <el-button @click="cancelAllSelect(index)">
                    清空
                  </el-button>
                  <el-button @click="onReSet(index)">
                    重置
                  </el-button>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <span class="other-footer">
            <el-button @click="editVisible = false">取 消</el-button>
            <el-button type="primary" @click="editStoreOpenTime">确 定</el-button>
          </span>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!--    设置店长弹框-->
    <el-dialog title="店长" v-model="managerModal" width="30%">
      <el-form ref="form" :model="managerForm" label-width="80px">
        <el-form-item label="姓名" required>
          <el-input v-model="managerForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model="managerForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="二维码" required>
          <el-input v-model="managerForm.qrcode"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="managerModal = false">取 消</el-button>
          <el-button type="primary" @click="saveManager">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!--    绑定保洁弹框-->
    <el-dialog title="保洁" v-model="cleaningModal" width="50%" class="cleanerDialog">
      <el-table ref="multipleTable2" :data="cleanerOptions" tooltip-effect="dark"
        style="width: 100%;height: 50vh;overflow-y: scroll;" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="55">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="120">
        </el-table-column>
        <el-table-column prop="phone" label="手机号">
        </el-table-column>
        <el-table-column prop="company_id" label="加盟商">
          <template #default="scope">{{ franchiseeMap.get(scope.row.company_id) }}</template>
        </el-table-column>
        <el-table-column prop="is_validate" label="是否有效">
          <template #default="scope">{{ scope.row.is_validate ? '有效' : '无效' }}</template>
        </el-table-column>
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cleaningModal = false">取 消</el-button>
          <el-button type="primary" @click="bindCleaners">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogVisible">
      <img ref="previewImage" :src="previewImage" style="width: 100%;" />
      <cropper ref="cropper" :src="previewImage" @ready="handleCropperReady" @cropmove="handleCropMove"
        style="width: 900px;" @cropend="handleCropEnd" />
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="getCroppedImage">裁剪并上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment, { weekdays } from "moment";
import TinymceText from '@/components/TinymceText'
import {
  getStoreList,
  saveStore,
  setStoreSort,
  setStoreIsvalidate,
  getStoreDetail,
  getAreaOption, saveStoreOpenTime, getFranchisee
} from "@/api/store";
import { getAdminOption } from "@/api/admin"
import { getManagerList, saveManager } from "@/api/manager"
import { getStoreOpenTime } from "@/api/store";
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { bindCleaner, getAllCleaner, getStoreCleaner } from "@/api/cleaning";
import { dataURLtoFile } from "@/utils/compress";
import { upload } from "@/api/editor";

export default {
  name: "storetable",
  components: { TinymceText },
  data() {
    return {
      action: 'https://wx.yixiankeji.com/admin/upload',
      editorOption: {
        placeholder: '编辑内容'
      },
      titleName: '',
      query: {
        name: "",
        area_id: null,
        is_validate: null,
        page: 1,
        page_size: 10
      },
      cleanerquery: {},
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      pageTotal: 0,
      form: {
        stop_start_at: 0,
        stop_end_at: 0,
        tude: "",
        auto_start_at: 0,
        auto_end_at: 0,
        hour_invert: false,
        start_hour: 0,
        end_hour: 0,
        week_day: '',
        type: null
      },
      options: [],
      area_options: [],
      idx: -1,
      id: -1,
      weekList: [
        { value: 1, label: '周一' },
        { value: 2, label: '周二' },
        { value: 3, label: '周三' },
        { value: 4, label: '周四' },
        { value: 5, label: '周五' },
        { value: 6, label: '周六' },
        { value: 7, label: '周日' },
      ],
      weekTime: [
        { value: 1, label: '周一' },
        { value: 2, label: '周二' },
        { value: 3, label: '周三' },
        { value: 4, label: '周四' },
        { value: 5, label: '周五' },
        { value: 6, label: '周六' },
        { value: 7, label: '周日' },
      ],
      managerModal: false, // 店长列表框
      managerForm: {
        "id": 0,
        "name": "", // 姓名
        "phone": "", // 手机
        "store_id": 0, // 门店id
        "qrcode": 0,
      },
      cleaningForm: {
        "id": 0,
        "ids": ''
      },
      // 店长提交信息
      managerData: [], // 店长信息
      dateList: [],
      rules: {
        name: [{ required: true, message: '请输入门店名称', trigger: 'blur' }],
        start_hour: [{ required: true, message: '请输入营业时间', trigger: 'change' }],
      },
      cleaningModal: false,
      cleanerOptions: [],
      checkAll: false,
      checkedCleaners: [],
      cleaners: [],
      isIndeterminate: true,
      timeList: [],
      activeTab: 'info',
      weekDays: [],
      weekMap: new Map(),
      cropper: null, // 裁切器实例
      dialogVisible: false,
      previewImage: '', // 预览图片
      updatePhotoLoading: false,
      franchiseeOptions: [],
      franchiseeMap: new Map(),
      croppedImages: [],
      file: {},
      img_upload_type:null
    };
  },
  created() {
    this.init()
  },

  computed: {},
  methods: {
    weekdays,
    init() {
      this.getData();
      this.getAdminOption()
      this.getAreaOption()
      this.getCleanerOptinos()
      this.getDayTime()
      this.getWeekMap()
      this.getAllFranchisee()
    },
    centerStyle() {
      return 'text-align:center'
    },
    handleSelectionChange(val) {
      this.checkedCleaners = val;
    },
    getWeekMap() {
      this.weekTime.forEach(item => {
        this.weekMap.set(item.value, item.label)
      })
    },
    // eslint-disable-next-line no-unused-vars
    release(content) {
    },
    tinymcechange(content) {
      this.form.content = content
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },

    hourFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return date.slice(0, 2) + ":" + date.slice(2, 4)
    },
    getData() {
      getStoreList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },

    getAllFranchisee() {
      getFranchisee().then(res => {
        res.push({ value: 0, label: '平台' })
        this.franchiseeOptions = res
        this.franchiseeOptions.forEach(item => {
          this.franchiseeMap.set(item.value, item.label)
        })
      })
    },

    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },

    getDayTime() {
      this.timeList = []
      for (let i = 0; i < 24; i++) {
        let itemTime = {}, itemTime2 = {}
        itemTime.time1 = (i < 10) ? ('0' + i + ':00') : (i + ':00')
        itemTime2.time1 = (i < 10) ? ('0' + (i + ':30')) : (i + ':30')
        this.timeList.push(itemTime)
        this.timeList.push(itemTime2)
      }
      this.timeList.forEach(item => {
        item.is_select = false
      })
      this.weekList.forEach(item => {
        item.timeList = JSON.parse(JSON.stringify(this.timeList))
      })
    },

    // 选择
    changeAtive(index, time_index) {
      this.weekList[index].timeList[time_index].is_select = !this.weekList[index].timeList[time_index].is_select
    },

    // 全选
    handleAllSelect(index) {
      this.weekList[index].timeList.forEach(item => {
        item.is_select = true
      })
    },

    // 清空
    cancelAllSelect(index) {
      this.weekList[index].timeList.forEach(item => {
        item.is_select = false
      })
    },

    // 重置
    onReSet(index) {
      getStoreOpenTime(this.form.id).then(res => {
        let reWeekList = res[index + 1]
        this.weekList[index].timeList.forEach((item, time_index) => {
          for (let key in reWeekList) {
            if (key == time_index) {
              item.is_select = reWeekList[key]
            }
          }
        })
      })

    },

    // tab切换
    changeTab() {
      if (this.form.id != 0) {
        this.getOpenTime()
      } else {
        this.cancelAll()
      }
    },

    // 获取门店营业时间
    getOpenTime() {
      getStoreOpenTime(this.form.id).then(res => {
        // 将得到的数据处理成想要的结构
        this.weekList.forEach(item => {
          if (JSON.stringify(res) != "{}") {
            for (let key in res) {
              if (key == item.value) {
                item.obj = res[key]
                item.timeList.forEach((time, index) => {
                  for (let time_key in item.obj) {
                    if (time_key == index) {
                      time.is_select = item.obj[time_key]
                    }
                  }
                })
              }
            }
          } else {
            item.timeList.forEach(time => {
              time.is_select = false
            })
          }
        })
      })
    },

    // 清空所有
    cancelAll() {
      for (let i = 0; i < this.weekList.length; i++) {
        this.weekList[i].timeList.forEach(item => {
          item.is_select = false
        })
      }
    },

    // 保存门店营业时间
    editStoreOpenTime() {
      // 将目前的数据处理成想要的数据，从内到外处理
      this.weekList.forEach(item => {
        item.obj = {}
        item.timeList.forEach((time, index) => {
          item.obj[index] = time.is_select
        })
      })
      let obj = {}
      this.weekList.forEach(item => {
        obj[item.value] = item.obj
      })
      saveStoreOpenTime(this.form.id, obj).then(res => {
        if (res) {
          this.$message.success('保存成功')
          this.editVisible = false
          this.getData()
        }
      })
    },

    // 添加操作
    handleAdd() {
      this.titleName = '添加'
      this.activeTab = 'info'
      this.form = {}
      this.form.id = 0
      this.form.start_hour = "00:00"
      this.form.end_hour = "00:00"
      this.form.stop_start_at_t = 0
      this.form.stop_end_at_t = 0
      this.form.image_list = []
      this.editVisible = true
      this.cancelAll()
      this.getAllFranchisee()
    },

    // 编辑操作
    handleEdit(index, row) {
      this.titleName = '编辑'
      this.activeTab = 'info'
      this.idx = index;
      getStoreDetail(row.id).then(res => {
        let week_day = res.week_day.split(';')
        this.weekDays = []
        week_day.forEach(item => {
          this.weekDays.push(this.weekMap.get(Number(item)))
        })
        this.form = res
        this.form.tude = this.form.latitude + "," + this.form.longitude
        this.form.start_hour = this.getNumberHour(this.form.start_hour, true)
        this.form.end_hour = this.getNumberHour(this.form.end_hour, true)
        this.form.stop_start_at_t = this.form.stop_start_at * 1000
        this.form.stop_end_at_t = this.form.stop_end_at * 1000
        this.getOpenTime()
        this.getAllFranchisee()
        this.editVisible = true
      })
    },

    // 获取负责人列表
    getAdminOption() {
      this.options = []
      getAdminOption().then(res => {
        res.forEach(function (val) {
          this.options.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },

    // 获取开放地区列表
    getAreaOption() {
      this.area_options = []
      getAreaOption().then(res => {
        res.forEach(function (val) {
          this.area_options.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },

    getNumberHour(hour, isNum) {
      if (hour === undefined) {
        return "00"
      }

      if (isNum && hour.length === 5) {
        return hour.slice(0, 2)
      }

      if (!isNum && hour.length === 4) {
        return hour.slice(0, 2)
      }

      if (isNum) {
        if (hour < 10) {
          return "0" + hour + ":00"
        }
        return hour + ":00"
      }

      return "00"
    },

    // 保存编辑
    saveEdit() {
      let week_day = []
      this.weekDays.forEach(item => {
        for (let i = 0; i < this.weekTime.length; i++) {
          if (item == this.weekTime[i].label) {
            week_day.push(this.weekTime[i].value)
          }
        }
      })
      this.form.week_day = week_day.join(';')
      if (this.form.tude !== undefined && this.form.tude !== "") {
        const tude = this.form.tude.split(",")
        this.form.latitude = parseFloat(tude[0])
        this.form.longitude = parseFloat(tude[1])
      }

      this.form.start_hour = parseInt(this.getNumberHour(this.form.start_hour, true))
      this.form.end_hour = parseInt(this.getNumberHour(this.form.end_hour, true))
      this.form.stop_start_at = new Date(this.form.stop_start_at_t).getTime() / 1000
      this.form.stop_end_at = new Date(this.form.stop_end_at_t).getTime() / 1000
      if (this.form.stop_end_at > 0 && this.form.stop_end_at <= this.form.stop_start_at) {
        this.$message.error("休业结束时间过早")
        return
      }

      saveStore(this.form.id, this.form).then(res => {
        if (res) {
          this.$message.success("保存成功")
          this.editVisible = false
          this.getData()
        }
      })
    },

    // 设置排序
    setSort(id, sort) {
      setStoreSort(id, sort).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
        }
      })
    },

    // 设置有效无效
    setIsvalidate(index, id, isvalidate) {
      setStoreIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      getStoreList(this.query).then(res => {
        this.tableData = res.data
      })
    },

    // eslint-disable-next-line no-unused-vars
    handleAvatarSuccess(res, file) {
      this.form.cover = res.url;
    },

    // eslint-disable-next-line no-unused-vars
    handleListSuccess(res, file) {
      this.form.image_list.push(res.url)
    },

    onFileChange() {
      // 处理图片预览
      const file = this.$refs.file
      this.fileName = file.files[0].name
      const blobData = window.URL.createObjectURL(file.files[0])
      this.previewImage = blobData
      // 展示弹出层，预览用户选择的图片
      this.dialogVisible = true
      // 解决选择相同图片不触发change事件的问题
      this.$refs.file.value = ''
    },
    onDialogOpened() {
      const image = this.$refs['preview-image']
      const cropper = new Cropper(image, {
        aspectRatio: 5 / 3,
        viewMode: 1,
        dragMode: 'none',
        background: true,
        cropBoxResizable: true,
      })
      this.cropper = cropper
    },
    onDialogClosed() {
      // this.cropper = null
      this.previewImage = ''
      this.fileName = ''
      this.cropper.destroy()
    },

    async onUpdatePhoto() {
      let img = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      let newImg = dataURLtoFile(img, this.fileName)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let formData = new FormData();
      formData.append("file", newImg.file);
      upload(formData).then(res => {
        if (res.url === undefined) {
          this.file = {}
        }
        this.form.cover = res.url
        this.file = {}

      })
      this.dialogVisible = false
      loading.close();
    },

    // 获取店长信息
    getManager(storeId) {
      this.managerForm = {
        "name": "",
        "phone": "",
        "id": 0,
        "store_id": storeId,
        "qrcode": ""
      }

      // 获取店长列表
      getManagerList({ store_id: storeId }).then(res => {
        for (const resKey in res.data) {
          this.managerForm.name = res.data[resKey].name
          this.managerForm.phone = res.data[resKey].phone
          this.managerForm.id = res.data[resKey].id
          this.managerForm.qrcode = res.data[resKey].qrcode
        }
        this.managerModal = true
      })
    },

    // 获取保洁
    getCleaning(id) {
      getStoreCleaner(id).then(res => {
        this.checkedCleaners = JSON.parse(JSON.stringify(res))
        let ids = [],
          rows = []
        this.checkedCleaners.forEach((item) => {
          for (let i = 0; i < this.cleanerOptions.length; i++) {
            if (item.id === this.cleanerOptions[i].id) {
              ids.push(i)
            }
          }
        })
        ids.forEach(item => {
          rows.push(this.cleanerOptions[item])
        })
        this.$refs.multipleTable2.clearSelection();
        this.toggleSelection(rows)
      })
      this.cleaningForm.id = id
      this.cleaningModal = true
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable2.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable2.clearSelection();
      }
    },
    // 保存店长信息
    saveManager() {
      if (this.managerForm.name == "") {
        this.$message.error('请输入姓名');
        return
      }
      if (this.managerForm.phone == "") {
        this.$message.error('请输入手机号');
        return;
      }

      // 新增-更新
      saveManager(this.managerForm.id, this.managerForm).then(res => {
        if (res == true) {
          this.$message.success('保存成功')
          this.managerModal = false
        }
        this.getData()
      })
    },

    // 全选
    handleCheckAllChange(val) {
      let newOptions = this.cleanerOptions.map(item => {
        return item.name
      })
      this.checkedCleaners = val ? newOptions : [];
      this.isIndeterminate = false;
    },

    // 点击保洁选择框
    handleCheckedCleanersChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cleaners.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cleaners.length;
    },

    // 获取保洁列表
    getCleanerOptinos() {
      getAllCleaner().then(res => {
        this.cleanerOptions = res
        this.cleaners = this.cleanerOptions
      })
    },

    // 绑定保洁
    bindCleaners() {
      this.cleaners.forEach(item => {
        for (let i = 0; i < this.checkedCleaners.length; i++) {
          if (item.name === this.checkedCleaners[i]) {
            this.checkedCleaners[i] = { name: item.name, id: item.id }
          }
        }
      })
      let newCleaners = this.checkedCleaners.map(item => {
        return item.id
      })
      this.cleaningForm.ids = newCleaners.join(',')
      bindCleaner(this.cleaningForm.id, this.cleaningForm).then(res => {
        if (res === true) {
          this.$message.success('绑定成功')
          this.cleaningModal = false
        }
      })
    },
    handlePictureCardPreview(file) {
      this.previewImage = file.url;
      this.fileName = file.name
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (!this.cropper) {
          this.cropper = new Cropper(this.$refs.previewImage, {
            aspectRatio: 5 / 3, // 可调整裁剪比例
            viewMode: 1, // 裁剪框外的图片是否可见
            dragMode: 'move', // 裁剪模式
          });
        } else {
          this.cropper.replace(file.url);
        }
      });
    },

    handleChange(file) {
      this.img_upload_type = 'image_list'
      this.handlePictureCardPreview(file)
      this.file = file
      this.dialogVisible = true
    },
    handleCoverChange(file) {
      this.img_upload_type = 'cover'
      this.handlePictureCardPreview(file)
      this.file = file
      this.dialogVisible = true
    },
    getCroppedImage() {
      let img = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      let newImg = dataURLtoFile(img, this.fileName)
      let formData = new FormData();
      formData.append("file", newImg.file);
      upload(formData).then(res => {
        if (res.url === undefined) {
          this.file = {}
        }
        let that = this
        if (this.img_upload_type == 'image_list') {
          let image_list = that.form.image_list
          if (image_list === undefined) {
            image_list = []
          }
          image_list.push(res.url)
          that.form.image_list = image_list
          this.file = {}
        }else if(this.img_upload_type == 'cover'){
          that.form.cover = res.url
        }
      })
      this.dialogVisible = false;
    },
    dataURItoBlob(dataURI) {
      // 将dataURL转换为Blob对象，以便上传
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
  },
  // 组件销毁前清理cropper
  beforeUnmount() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar2 {
  width: 148px;
  height: 148px;
  display: block;
  border-radius: 5px;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
}

.tip {
  color: #a4a2a2;
  font-size: 12px;
  margin-left: 10px;
}

.w400 {
  width: 400px;
}

.qf {
  width: 130px;
  margin-left: 10px;
  display: inline-block;
  border: 1px solid #DCDFE6;
  padding: 0 10px;
  box-sizing: border-box;
  border-radius: 5px;
  color: #606266;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 3px 0px #eee;
}

.ml10 {
  margin-left: 5px;
}

.demo-collapse {
  margin: 0 auto;
  width: 90%;
  margin-top: 30px;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.el-collapse {
  width: 90%;
}

.time_box {
  display: flex;
  flex-wrap: wrap;
}

.time_item {
  width: 100px;
  border: 1px solid #b7b6b6;
  text-align: center;
  padding: 5px 0px;
  margin: 5px 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 0px #e3e2e2;
  color: gray;
}

.time_active {
  width: 100px;
  background: #69aae7;
  color: white;
  text-align: center;
  padding: 5px 0px;
  margin: 5px 10px;
  border-radius: 10px;
  border: 1px solid #69aae7;
  box-shadow: 0px 0px 5px 0px #c0c0c0;
  font-size: 15px;
}

.other-footer {
  float: right;
  margin-right: 15%;
  margin-top: 30px;
}

.btn_style {
  float: right;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 50px;
}

/deep/ .el-tabs__item {
  width: 100px;
  text-align: center;
}

.el-button-problem {
  font-size: 20px;
  margin-left: 10px;
}

/deep/ .cropper-bg {
  width: 900px !important;
}

/deep/ .cropper-modal {
  width: 900px;
}

/deep/ .cropper-wrap-box {
  width: 900px;
}

.dialog-footer {
  margin-top: 30px;
}

::v-deep .el-upload--picture-card{
  width: 148px !important;
  height: 148px !important;
}
</style>